import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Fish, LayoutDashboard, Newspaper, FileText, Image, Calendar, MessageSquare, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { ADMIN } from "@/constants/testIds";

const links = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, slug: "overview", end: true },
  { to: "/admin/berita", label: "Berita", icon: Newspaper, slug: "berita" },
  { to: "/admin/regulasi", label: "Regulasi", icon: FileText, slug: "regulasi" },
  { to: "/admin/galeri", label: "Galeri", icon: Image, slug: "galeri" },
  { to: "/admin/agenda", label: "Agenda", icon: Calendar, slug: "agenda" },
  { to: "/admin/kontak", label: "Pesan Kontak", icon: MessageSquare, slug: "kontak" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="w-64 bg-[#003A5C] text-white flex flex-col fixed left-0 top-0 bottom-0 thin-scroll overflow-y-auto">
        <Link to="/admin" className="flex items-center gap-3 px-5 py-6 border-b border-white/10">
          <div className="w-10 h-10 rounded-xl bg-white grid place-items-center p-1.5">
            <img src="/assets/silaing/logo-jabar.png" alt="Logo Pemprov Jabar" className="w-full h-full object-contain" />
          </div>
          <div>
            <div className="font-heading font-bold text-lg leading-none">SILAING</div>
            <div className="text-[10px] uppercase tracking-widest text-[#48CAE4] mt-1">Admin Panel</div>
          </div>
        </Link>

        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.slug}
              to={l.to}
              end={l.end}
              data-testid={ADMIN.sidebarLink(l.slug)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-[#00B4D8] text-[#003A5C]" : "text-white/80 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <l.icon className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-white/10 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-xs text-white/70 hover:text-[#48CAE4] px-3 py-2">
            <ExternalLink className="w-3.5 h-3.5" /> Lihat Situs Publik
          </Link>
          <div className="px-3 py-2 text-xs text-white/60">
            <div className="font-semibold text-white/90 truncate">{user?.email}</div>
            <div>Peran: {user?.role}</div>
          </div>
          <button
            data-testid={ADMIN.logout}
            onClick={() => { logout(); nav("/admin/login"); }}
            className="w-full inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 rounded-lg py-2 text-sm"
          >
            <LogOut className="w-4 h-4" /> Keluar
          </button>
        </div>
      </aside>

      <main className="ml-64 flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}
